import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section aria-labelledby="bonos" className="w-full bg-ink" data-id="element-14" data-mp="piy2uloqjvk1">
      <div className="mx-auto max-w-content px-5 py-16 lg:py-24" data-id="element-15" data-mp="avcw8hsnje7d">
        <div className="mx-auto max-w-2xl text-center" data-id="element-16" data-mp="asz5gl508o5m">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold/40 px-4 py-1.5 text-[12px] font-semibold uppercase tracking-[0.16em] text-gold" data-id="element-17" data-mp="ft4ojcx7l2c3">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-18" data-mp="5vqlqg47kc29" />
            Incluidos hoy gratis
          </span>
          <h2 id="bonos" className="mt-5 font-display text-3xl text-cream sm:text-4xl" data-id="element-19" data-mp="3o2eohzbscn4r">
            3 bonos exclusivos incluidos
          </h2>
          <p className="mt-4 text-[15px] text-muted" data-id="element-20" data-mp="3t0yau0uak0xn">
            Valor total AR$ 32.970 — incluidos hoy sin costo adicional.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-21" data-mp="1r9l8njjpk75a">
          {bonuses.map(bonus => <li key={bonus.number} className="flex h-full flex-col rounded-2xl border border-line bg-ink-raised p-7" data-id="element-22" data-mp="3ie6hjg9krzv5">
              <p className="text-[12px] font-semibold uppercase tracking-[0.16em] text-amethyst" data-id="element-23" data-mp="3dg4ygvc5g0jo">
                {bonus.number}
              </p>
              <h3 className="mt-3 font-sans text-[17px] font-semibold leading-snug text-cream" data-id="element-24" data-mp="3r5yqtnmv52y5">
                {bonus.title}
              </h3>
              <p className="mt-3 text-[14px] leading-relaxed text-muted" data-id="element-25" data-mp="2zf2b8f9f4k76">{bonus.detail}</p>
              <p className="mt-auto flex items-baseline gap-3 pt-6" data-id="element-26" data-mp="2ugr0m2bau5nw">
                <span className="text-[14px] text-muted line-through" data-id="element-27" data-mp="2uik5pd69khts">Valor {bonus.price}</span>
                <span className="font-sans text-[14px] font-bold uppercase tracking-wide text-gold" data-id="element-28" data-mp="38e5v3lget3mq">
                  Gratis
                </span>
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}